// types
import { ProfileSBACertsExtended } from "types/profile.types";

// components
import { SBATag } from "components/LibraryComponents/Components";
import { Alert } from "@trussworks/react-uswds";

// utils
import { getSBACertTitle, formatCertDate } from "utils/profile";

// styles
import styles from "./ProfileCertifications.module.scss";

type SBACertificateCardProps = {
  name: string;
  active: boolean;
  status?: string | null;
  entranceDate: string;
  exitDate?: string;
  suspended?: boolean;
  pending?: boolean;
  servicingOffice?: string;
  officeId?: string;
}

export default function SBACertificateCard(props: SBACertificateCardProps) {
  const { 
    name, 
    active,
    entranceDate,
    exitDate,
    suspended,
    pending,
    servicingOffice,
    officeId
  } = props;

  const title = getSBACertTitle(name);
  const bgColor = active ? "#538200" : "#565C65"

  const is8A = name === "8(a)"
  const is8AJV = name === "8(a) JV"
  // const isVOSBJV = name === "VOSB JV"
  const isVOSB = name === "VOSB";
  const isSDVOSB = name === "SDVOSB";

  const servicing_office_text = servicingOffice ? officeId ? `${servicingOffice} (SBA Office code ${officeId})` : servicingOffice : null;

  return (
    <>
      <div className={styles["sba-cert-card-root"]}>
        <h4 className={styles["title"]}>{title}</h4>

        {!suspended && active && !pending && (
          <SBATag
            name={`${name} Certified`}
            isPending={pending}
            background={bgColor}
          />
        )}

        {pending && (
          <SBATag
            name={`${name} Pending`}
            isPending={pending}
            background={bgColor}
          />
        )}

        {!suspended && !active && !pending && (
          <SBATag
            name={`Previously ${name} certified`}
            isPending={pending}
            background={bgColor}
          />
        )}

        {suspended && (
          <Alert
            type="warning"
            headingLevel="h6"
            className={styles["alert-wrapper"]}
          >
            This certification is currently suspended.
          </Alert>
        )}

        {is8A && (
          <div className={styles["content"]}>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Entrance date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(entranceDate)}
              </p>
            </div>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Exit date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(exitDate)}
              </p>
            </div>
            {servicingOffice && (
              <div className={styles["data-field"]}>
                <h5 className={styles["label"]}>SBA Servicing Office:</h5>
                <p className={styles["value"]}>{servicing_office_text}</p>
              </div>
            )}
          </div>
        )}

        {is8AJV && (
          <div className={styles["content"]}>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Entrance date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(entranceDate)}
              </p>
            </div>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Exit date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(exitDate)}
              </p>
            </div>
            {servicingOffice && (
              <div className={styles["data-field"]}>
                <h5 className={styles["label"]}>SBA Servicing Office:</h5>
                <p className={styles["value"]}>{servicing_office_text}</p>
              </div>
            )}
            {/* <p className={styles["quote"]}>
              NOTE: Notify your servicing SBA Business Opportunity Specialist to
              have your 8(a) joint venture approval date reflected here.
            </p> */}
          </div>
        )}

        {/* {isVOSBJV && (
          <div className={styles["content"]}>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Entrance date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(entranceDate)}
              </p>
            </div>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Exit date:</h5>
              <p className={styles["value"]}>
                {formatCertDate(exitDate)}
              </p>
            </div>
          </div>
        )} */}

        {(isVOSB || isSDVOSB) && (
          <div className={styles["content"]}>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Entrance date:</h5>
              <p className={styles["value"]}>{formatCertDate(entranceDate)}</p>
            </div>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Exit date:</h5>
              <p className={styles["value"]}>{formatCertDate(exitDate)}</p>
            </div>
          </div>
        )}

        {!is8A && !is8AJV && !isVOSB && !isSDVOSB && (
          <div className={styles["content"]}>
            <div className={styles["data-field"]}>
              <h5 className={styles["label"]}>Entrance date:</h5>
              <p className={styles["value"]}>{formatCertDate(entranceDate)}</p>
            </div>
            {!active && !pending && (
              <div className={styles["data-field"]}>
                <h5 className={styles["label"]}>Exit date:</h5>
                <p className={styles["value"]}>{formatCertDate(exitDate)}</p>
              </div>
            )}
          </div>
        )}
      </div>

      <hr className={styles["divider"]} />
    </>
  );
}
